if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      connectedCallback() {
       this.setupTabletSwipe();
       requestAnimationFrame(() => this.filterColourMedia());
       }
       // Corrosion FREE: swipe between images on larger touch screens.
setupTabletSwipe() {
  const viewer = this.elements.viewer;
  if (!viewer || this.cfSwipeReady) return;
  this.cfSwipeReady = true;

  const enabled = () =>
    this.mql.matches &&
    window.matchMedia('(any-pointer: coarse)').matches &&
    (this.dataset.desktopLayout || '').includes('thumbnail');

  let start = null;
  let suppressClickUntil = 0;

  viewer.addEventListener('touchstart', (event) => {
    start = null;
    if (!enabled() || event.touches.length !== 1) return;

    const slide = event.target.closest('li[data-media-id]');

    // Leave videos, 3D models and their controls alone.
    if (!slide?.querySelector('.product__modal-opener--image')) return;

    start = {
      x: event.touches[0].clientX,
      y: event.touches[0].clientY,
      time: Date.now(),
      mediaId: slide.dataset.mediaId,
    };
  }, { passive: true });

  viewer.addEventListener('touchend', (event) => {
    const gesture = start;
    start = null;

    if (!gesture || !enabled() || !event.changedTouches.length) return;

    const dx = event.changedTouches[0].clientX - gesture.x;
    const dy = event.changedTouches[0].clientY - gesture.y;

    // Ignore taps, vertical scrolling and long gestures.
    if (
      Date.now() - gesture.time > 1000 ||
      Math.abs(dx) < 50 ||
      Math.abs(dx) < Math.abs(dy) * 1.5
    ) return;

    // The colour filter hides excluded slides with inline display:none.
    const slides = Array.from(
      viewer.querySelectorAll('li[data-media-id]')
    ).filter((slide) =>
      !slide.hidden && slide.style.display !== 'none'
    );

    const currentIndex = slides.findIndex(
      (slide) => slide.dataset.mediaId === gesture.mediaId
    );
    if (currentIndex < 0 || slides.length < 2) return;

    suppressClickUntil = Date.now() + 500;

    const nextIndex = currentIndex + (dx < 0 ? 1 : -1);

    // Stop at the first or last image.
    if (nextIndex < 0 || nextIndex >= slides.length) return;

    this.setActiveMedia(slides[nextIndex].dataset.mediaId, false);
  }, { passive: true });

  viewer.addEventListener('touchcancel', () => {
    start = null;
  }, { passive: true });

  // Prevent a swipe from also opening image zoom.
  viewer.addEventListener('click', (event) => {
    if (Date.now() < suppressClickUntil) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}

      filterColourMedia(featuredMediaId) {
        const viewer = this.elements.viewer;
        if (!viewer) return;

        const slides = Array.from(
          viewer.querySelectorAll('li[data-media-id]')
        );

        const getColour = (slide) => {
          const alt = slide?.querySelector('img')?.getAttribute('alt') || '';
          return alt.match(/\[color:([^\]]+)\]/i)?.[1]
            .trim()
            .toLowerCase();
        };

        if (!slides.some((slide) => getColour(slide))) return;

        const featured = featuredMediaId
          ? slides.find((slide) => slide.dataset.mediaId === featuredMediaId)
          : slides.find((slide) => slide.classList.contains('is-active'));

        const colour = getColour(featured) || this.cfMediaColour;
        if (!colour) return;
        this.cfMediaColour = colour;

        const visibleIds = new Set();

        slides.forEach((slide) => {
          const slideColour = getColour(slide);
          const hide = Boolean(slideColour && slideColour !== colour);

          if (hide) {
            slide.style.setProperty('display', 'none', 'important');
          } else {
            slide.style.removeProperty('display');
            visibleIds.add(slide.dataset.mediaId);
          }
        });

        let position = 0;

        this.elements.thumbnails
          ?.querySelectorAll('li[data-target]')
          .forEach((thumbnail) => {
            if (visibleIds.has(thumbnail.dataset.target)) {
              thumbnail.style.removeProperty('display');
              thumbnail.dataset.mediaPosition = String(++position);
            } else {
              thumbnail.style.setProperty('display', 'none', 'important');
            }
          });

        viewer.resetPages?.();
        this.elements.thumbnails?.resetPages?.();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
                if (prepend) this.filterColourMedia(mediaId);
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
